import { titleCase as titleCaseLib } from "title-case"

export default function titleCase(text) {
  if (!text) return text;

  const isAllCaps = text === text.toUpperCase()

  if (isAllCaps) return titleCaseLib(text.toLowerCase());
  return titleCaseLib(text);
}
